export default {
  getSelectedDossierTask(state) {
    return state.selectedDossierTask
  }
}
